import React, { forwardRef } from 'react';
import c from 'classnames';

import BaseIconButton from '../BaseIconButton';
import { BORDER_RADIUS, COLOR_CLASSES, ICONBUTTON_SIZE, TEXT_COLOR_CLASSES } from '../utils/utils';
import { DeprecatedIconButtonProps } from './types';

const DeprecatedIconButton = forwardRef<HTMLButtonElement, DeprecatedIconButtonProps>(
  (props, ref) => {
    const {
      appearance = 'primary',
      children,
      className,
      Icon,
      shape = 'theme',
      size = 'medium',
      variant = 'filled',
      ...rest
    } = props;

    const sizeClasses = ICONBUTTON_SIZE[size];
    const shapeClasses = BORDER_RADIUS[shape];
    const colorClasses = COLOR_CLASSES[variant][appearance];
    const textColorClasses = TEXT_COLOR_CLASSES[variant][appearance];

    return (
      <BaseIconButton
        ref={ref}
        className={c(
          'flex py-0 items-center',
          sizeClasses,
          shapeClasses,
          colorClasses,
          textColorClasses,
          className,
        )}
        {...rest}>
        {Icon ? <Icon /> : children}
      </BaseIconButton>
    );
  },
);

export { DeprecatedIconButtonProps };
export default DeprecatedIconButton;
